// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3FknK","visuallyhidden":"_3VJVY","hide-text":"_1rWco","center":"_1OnOM","noprint":"iNQw5","root":"_3L2at"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-break/styles/Break.scss
 ** module id = 937
 ** module chunks = 1
 **/